import {ChatRuntimeProvider} from "@/components/chat-runtime-provider";
import {Thread} from "@/components/assistant-ui/thread";

export function ChatPage() {
  return (
    <ChatRuntimeProvider>
      <div className="flex min-h-0 flex-1 flex-col">
        <Thread />
      </div>
    </ChatRuntimeProvider>
  );
}
